var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodiCLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76404 7.7509C1.76394 4.88698 3.4652 2.298 6.09047 1.16693C8.71574 0.0358577 11.7609 0.579918 13.8344 2.55051L13.826 2.55321C14.1758 2.88588 14.3159 3.38372 14.1911 3.85057C14.0664 4.31742 13.6968 4.67842 13.2279 4.79134C12.759 4.90426 12.266 4.75098 11.9433 4.39191C10.1267 2.74422 7.33078 2.84815 5.64103 4.62618C3.95127 6.40421 3.98374 9.20812 5.71422 10.9464C7.4447 12.6846 10.2423 12.7235 12.0202 11.034L12.0463 11.0621C12.2847 10.8366 12.6001 10.711 12.9279 10.7109C13.6589 10.7198 14.2443 11.3209 14.2356 12.0535C14.2387 12.5796 13.9354 13.0592 13.4594 13.2809C11.3239 15.0439 8.36525 15.4138 5.86304 14.2307C3.36083 13.0476 1.76432 10.5238 1.76404 7.7509Z",
    fill: "#0078FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiCLogo);
export default __webpack_public_path__ + "static/media/Codi-C-Logo.bb0560d0e87c85a4e805bdb9a88a2468.svg";
export { ForwardRef as ReactComponent };